export default "__VITE_ASSET__BJEKFuOh__"